export const name = 'Fysio Hier';
export const baseUrl = 'https://fysiohier.com';
export const generalMail = 'info@fysiohier.com';
export const logoUrl = 'https://fysiohier.com/img/logo/fysio-hier-icon-center-dark@2x.png';
